// extracted by mini-css-extract-plugin
module.exports = {"social":"Social-module--social--34_X_"};